export const Colors = {
  baseTextColor: "#306e7d",
  secondaryColor: "#030986",
};
